import { render, staticRenderFns } from "./CellRendererTrash.vue?vue&type=template&id=2f043c89&scoped=true&"
import script from "./CellRendererTrash.vue?vue&type=script&lang=js&"
export * from "./CellRendererTrash.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererTrash.vue?vue&type=style&index=0&id=2f043c89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f043c89",
  null
  
)

export default component.exports